import React, { useState, useEffect, useRef } from 'react';
// import { useEditStore } from '../stores';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';
import ExampleColorPickerView from './exampleColorPickerView';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import ListFont from './custom/ListFont';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { InputBase } from '@material-ui/core';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

export function EditThemeContent({ data, func }) {
  console.log('ini data style theme', data);
  // console.log("ini data style theme", data.style.paperColor)

  const [load, setLoad] = useState(false);
  const [getstyles, setGetstyles] = useState(
    reactCSS({
      default: {
        paperColor: {
          color: '',
        },
        paperColorTrigger: {
          border: '2px solid #808080',
          width: '100px',
          padding: '7px 10px',
          borderRadius: '2px',
          color: '#505050',
          background: '',
          display: 'flex',
          justifyContent: 'center',
        },
        bgPaperColor: {
          background: '',
        },
        bgPaperColorTrigger: {
          border: '2px solid #808080',
          width: '100px',
          padding: '7px 10px',
          borderRadius: '2px',
          color: `white`,
          background: '',
          display: 'flex',
          justifyContent: 'center',
        },
        questionColor: {
          color: '',
        },
        questionColorTrigger: {
          border: '2px solid #808080',
          width: '100px',
          padding: '7px 10px',
          borderRadius: '2px',
          color: `white`,
          background: '',
          display: 'flex',
          justifyContent: 'center',
        },
        answerColor: {
          color: '',
        },
        answerColorTrigger: {
          border: '2px solid #808080',
          width: '100px',
          padding: '7px 10px',
          borderRadius: '2px',
          color: `white`,
          background: '',
          display: 'flex',
          justifyContent: 'center',
        },
        stripColor: {
          background: '',
        },
        stripColorTrigger: {
          border: '2px solid #808080',
          width: '100px',
          padding: '7px 10px',
          borderRadius: '2px',
          color: `white`,
          background: '',
          display: 'flex',
          justifyContent: 'center',
        },
        buttonBgColor: {
          color: '',
        },
        buttonBgColorTrigger: {
          border: '2px solid #808080',
          width: '100px',
          padding: '7px 10px',
          borderRadius: '2px',
          color: `white`,
          background: '',
          display: 'flex',
          justifyContent: 'center',
        },
        fontStyle: {
          fontFamily: '',
        },
        fontStylee: {
          fontFamily: 'Roboto',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          // boxShadow: "0 1px 0 0 rgba(0,0.1,0,0)",
          // border: "1px solid #DCDCDC",
          display: 'inline-block',
          cursor: 'pointer',
        },
      },
    })
  );

  const [defaultFont, setDefaultFont] = useState('Poppins');
  const [colorHexPaperCode, setColorHexPaperCode] = useState('#FFFFFF');
  const [colorHexPaperBgCode, setColorHexPaperBgCode] = useState('#FFFFFF');
  const [colorHexQuestionCode, setColorHexQuestionCode] = useState('#000000');
  const [colorHexAnswerCode, setColorHexAnswerCode] = useState('#000000');
  const [colorHexStripCode, setColorHexStripCode] = useState('#000000');
  const [colorHexButtonCode, setColorHexButtonCode] = useState('#B83400');

  const [newTheme, setNewTheme] = useState({
    fontType: `${defaultFont}`,
    paperColor: `${colorHexPaperCode}`,
    backgroundPaperColor: `${colorHexPaperBgCode}`,
    backgroundImagePaperColor: ``,
    questionColor: `${colorHexQuestionCode}`,
    answerColor: `${colorHexAnswerCode}`,
    stripColor: `${colorHexStripCode}`,
    backgroundButtonColor: `${colorHexButtonCode}`,
  });

  func(newTheme); //oper state to parent EDIT

  const [displayCPPaper, setDisplayCPPaper] = useState(false);
  const [displayCPBgPaper, setDisplayCPBgPaper] = useState(false);
  const [displayCPQuestion, setDisplayCPQuestion] = useState(false);
  const [displayCPAnswer, setDisplayCPAnswer] = useState(false);
  const [displayCPStrip, setDisplayCPStrip] = useState(false);
  const [displayCPButton, setDisplayCPButton] = useState(false);

  const handleDisplayCPPaper = () => {
    setDisplayCPPaper(!displayCPPaper);
  };
  const handleDisplayCPBgPaper = () => {
    setDisplayCPBgPaper(!displayCPBgPaper);
  };
  const handleDisplayCPQuestion = () => {
    setDisplayCPQuestion(!displayCPQuestion);
  };
  const handleDisplayCPAnswer = () => {
    setDisplayCPAnswer(!displayCPAnswer);
  };
  const handleDisplayCPStrip = () => {
    setDisplayCPStrip(!displayCPStrip);
  };
  const handleDisplayCPButton = () => {
    setDisplayCPButton(!displayCPButton);
  };

  const handleClose = () => {
    setDisplayCPPaper(false);
  };

  const changeQuestion = (e, text, i) => {
    setColorHexQuestionCode(e.hex);
    setNewTheme({
      fontType: defaultFont,
      paperColor: colorHexPaperCode,
      backgroundPaperColor: colorHexPaperBgCode,
      backgroundImagePaperColor: ``,
      questionColor: colorHexQuestionCode,
      answerColor: colorHexAnswerCode,
      stripColor: colorHexStripCode,
      backgroundButtonColor: colorHexButtonCode,
    });
  };

  // const themes = useSelector((state) => state.redTheme);
  // console.log('ini single theme', themes);
  // useEffect(() => {
  //   const load = setTimeout(() => {
  //     setLoad(true);
  //   }, 1000);
  //   return () => clearTimeout(load);
  // }, [data]);
  useEffect(() => {
    const styleLoad = setTimeout(() => {
      setColorHexPaperCode(`${data.style.paperColor}`);
      setColorHexPaperBgCode(`${data.style.backgroundPaperColor}`);
      setColorHexQuestionCode(`${data.style.questionColor}`);
      setColorHexAnswerCode(`${data.style.answerColor}`);
      setColorHexStripCode(`${data.style.stripColor}`);
      setColorHexButtonCode(`${data.style.backgroundButtonColor}`);
      setGetstyles(
        reactCSS({
          default: {
            paperColor: {
              background: `${data.style.paperColor}`,
            },
            paperColorTrigger: {
              border: '2px solid #808080',
              width: '100px',
              padding: '7px 10px',
              borderRadius: '2px',
              color: '#505050',
              background: `${data.style.paperColor}`,
              display: 'flex',
              justifyContent: 'center',
            },
            bgPaperColor: {
              background: `${data.style.backgroundPaperColor}`,
            },
            bgPaperColorTrigger: {
              border: '2px solid #808080',
              width: '100px',
              padding: '7px 10px',
              borderRadius: '2px',
              color: `white`,
              background: `${data.style.backgroundPaperColor}`,
              display: 'flex',
              justifyContent: 'center',
            },
            questionColor: {
              color: `${data.style.questionColor}`,
            },
            questionColorTrigger: {
              border: '2px solid #808080',
              width: '100px',
              padding: '7px 10px',
              borderRadius: '2px',
              color: `white`,
              background: `${data.style.questionColor}`,
              display: 'flex',
              justifyContent: 'center',
            },
            answerColor: {
              color: `${data.style.answerColor}`,
            },
            answerColorTrigger: {
              width: '100px',
              padding: '7px 10px',
              borderRadius: '2px',
              color: `white`,
              background: `${data.style.answerColor}`,
              display: 'flex',
              justifyContent: 'center',
            },
            stripColor: {
              background: `${data.style.stripColor}`,
            },
            stripColorTrigger: {
              width: '100px',
              padding: '7px 10px',
              borderRadius: '2px',
              color: `white`,
              background: `${data.style.stripColor}`,
              display: 'flex',
              justifyContent: 'center',
            },
            buttonBgColor: {
              color: `${data.style.backgroundButtonColor}`,
            },
            buttonBgColorTrigger: {
              width: '100px',
              padding: '7px 10px',
              borderRadius: '2px',
              color: `white`,
              background: `${data.style.backgroundButtonColor}`,
              display: 'flex',
              justifyContent: 'center',
            },
            fontStyle: {
              fontFamily: `${data.style.fontType}`,
            },
          },
        })
      );
    }, 4000);
    return () => clearTimeout(styleLoad);
  }, [data]);

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 });
    return isDesktop ? children : Default;
  };
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    return isTablet ? children : null;
  };
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };
  const Default = ({ children }) => {
    const isNotTabletAndMobile = useMediaQuery({
      minWidth: 768,
      maxWidth: 990,
    });
    return isNotTabletAndMobile ? children : null;
  };

  const baseImg =
    'https://cdn.pixabay.com/photo/2017/06/09/07/42/flower-2386049_960_720.jpg';

  const handleImgError = (e) => {
    e.target.src = baseImg;
  };

  let contentUi = <div className='loader-block' />;

  const newStyles = reactCSS({
    default: {
      paperColor: {
        background: `${colorHexPaperCode}`,
      },
      paperColorTrigger: {
        border: '2px solid #808080',
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: '#505050',
        background: `${colorHexPaperCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      bgPaperColor: {
        background: `${colorHexPaperBgCode}`,
      },
      bgPaperColorTrigger: {
        border: '2px solid #808080',
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: '#505050',
        background: `${colorHexPaperBgCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      questionColor: {
        color: `${colorHexQuestionCode}`,
      },
      questionColorTrigger: {
        border: '2px solid #808080',
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexQuestionCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      answerColor: {
        color: `${colorHexAnswerCode}`,
      },
      answerColorTrigger: {
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexAnswerCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      stripColor: {
        background: `${colorHexStripCode}`,
      },
      stripColorTrigger: {
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexStripCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      buttonBgColor: {
        color: `${colorHexButtonCode}`,
      },
      buttonBgColorTrigger: {
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexButtonCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      fontStylee: {
        fontFamily: 'Roboto',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        // boxShadow: "0 1px 0 0 rgba(0,0.1,0,0)",
        // border: "1px solid #DCDCDC",
        display: 'inline-block',
        cursor: 'pointer',
      },
    },
  });

  if (data) {
    contentUi = (
      <>
        <Desktop>
          <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
            <div className='sm:grid-cols-3 grid sm:gap-2 gap-3 mt-6'>
              <div className=' overflow-hidden rounded-lg'>
                <div className='p-5'>
                  <div className='flex items-center'>
                    <div className='flex-auto'>
                      <span className='text-center text-md'>Font</span>
                    </div>

                    <div className='w-2/4'>
                      <FormControl style={getstyles.formControl}>
                        <Select
                          input={<BootstrapInput />}
                          placeholder='Pilih Font'
                          defaultValue='Pilih Font'
                          // onChange={handleChangeFont}
                        >
                          <MenuItem value='Pilih Font'>
                            <em>-- Pilih Font --</em>
                          </MenuItem>
                          <MenuItem value='Roboto, sans-serif'>
                            {' '}
                            <ListFont
                              fontName='Roboto'
                              fontStyle='Roboto, sans-serif'
                            />
                          </MenuItem>
                          <MenuItem value='Roboto Mono, monospaced'>
                            {' '}
                            <ListFont
                              fontName='Roboto Mono'
                              fontStyle='Roboto Mono, monospaced'
                            />
                          </MenuItem>
                          <MenuItem value='Qahiri, sans-serif'>
                            {' '}
                            <ListFont
                              fontName='Qahiri'
                              fontStyle='Qahiri, sans-serif'
                            />
                          </MenuItem>
                          <MenuItem value='STIX Two Math, serif'>
                            {' '}
                            <ListFont
                              fontName='STIX Two Math'
                              fontStyle='STIX Two Math, serif'
                            />
                          </MenuItem>
                          <MenuItem value='Teko, sans-serif'>
                            {' '}
                            <ListFont
                              fontName='Teko'
                              fontStyle='Teko, sans-serif'
                            />
                          </MenuItem>
                          <MenuItem value='Bebas Neue, cursive'>
                            {' '}
                            <ListFont
                              fontName='Bebas Neue'
                              fontStyle='Bebas Neue, cursive'
                            />
                          </MenuItem>
                          <MenuItem value='Anton, sans-serif'>
                            {' '}
                            <ListFont
                              fontName='Anton'
                              fontStyle='Anton, sans-serif'
                            />
                          </MenuItem>
                          <MenuItem value='Barlow Condensed, sans-serif'>
                            {' '}
                            <ListFont
                              fontName='Barlow Condensed'
                              fontStyle='Barlow Condensed, sans-serif'
                            />
                          </MenuItem>
                          <MenuItem value='Source Code Pro, monospace'>
                            {' '}
                            <ListFont
                              fontName='Source Code Pro'
                              fontStyle='Source Code Pro, monospace'
                            />
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div className='flex flex-wrap items-center mb-4 mt-4'>
                    <div className='flex-auto'>
                      <span className='text-center text-md'>Paper Color</span>
                    </div>
                    <div
                      style={newStyles.swatch}
                      onClick={handleDisplayCPPaper}
                      className='w-2/4'
                    >
                      <div
                        style={newStyles.paperColorTrigger}
                        message={newStyles.paperColor}
                      >
                        <span className='items-center text-xs text-center font-bold uppercase'>
                          {colorHexPaperCode}
                        </span>
                      </div>
                      {displayCPPaper ? (
                        <div style={newStyles.popover}>
                          <div style={newStyles.cover} onClick={handleClose} />
                          <SketchPicker
                            color={colorHexPaperCode}
                            onChange={(e) => setColorHexPaperCode(e.hex)}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className='flex flex-wrap items-center mb-4 mt-4'>
                    <div className='flex-auto'>
                      <span className='text-center text-md'>
                        Background Paper Color
                      </span>
                    </div>
                    <div
                      style={newStyles.swatch}
                      onClick={handleDisplayCPBgPaper}
                      className='w-2/4'
                    >
                      <div
                        style={newStyles.bgPaperColorTrigger}
                        message={newStyles.bgPaperColor}
                      >
                        <span className='items-center text-xs text-center font-bold uppercase'>
                          {colorHexPaperBgCode}
                        </span>
                      </div>
                      {displayCPBgPaper ? (
                        <div style={newStyles.popover}>
                          <div style={newStyles.cover} onClick={handleClose} />
                          <SketchPicker
                            color={colorHexPaperBgCode}
                            onChange={(e) => setColorHexPaperBgCode(e.hex)}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className='flex flex-wrap items-center mb-4 mt-4'>
                    <div className='flex-auto'>
                      <span className='text-center text-md'>
                        Question Color
                      </span>
                    </div>
                    <div
                      style={newStyles.swatch}
                      onClick={handleDisplayCPQuestion}
                      className='w-2/4'
                    >
                      <div
                        style={newStyles.questionColorTrigger}
                        message={newStyles.questionColor}
                      >
                        <span className='items-center text-xs text-center font-bold uppercase'>
                          {colorHexQuestionCode}
                        </span>
                      </div>
                      {displayCPQuestion ? (
                        <div style={newStyles.popover}>
                          <div style={newStyles.cover} onClick={handleClose} />
                          <SketchPicker
                            color={colorHexQuestionCode}
                            onChange={changeQuestion}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className='flex flex-wrap items-center mb-4 mt-4'>
                    <div className='flex-auto'>
                      <span className='text-center text-md'>Answer Color</span>
                    </div>
                    <div
                      style={newStyles.swatch}
                      onClick={handleDisplayCPAnswer}
                      className='w-2/4'
                    >
                      <div
                        style={newStyles.answerColorTrigger}
                        message={newStyles.answerColor}
                      >
                        <span className='items-center text-xs text-center font-bold uppercase'>
                          {colorHexAnswerCode}
                        </span>
                      </div>
                      {displayCPAnswer ? (
                        <div style={newStyles.popover}>
                          <div style={newStyles.cover} onClick={handleClose} />
                          <SketchPicker
                            color={colorHexAnswerCode}
                            onChange={(e) => setColorHexAnswerCode(e.hex)}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className='flex flex-wrap items-center mb-4 mt-4'>
                    <div className='flex-auto'>
                      <span className='text-center text-md'>Strip Color</span>
                    </div>
                    <div
                      style={newStyles.swatch}
                      onClick={handleDisplayCPStrip}
                      className='w-2/4'
                    >
                      <div
                        style={newStyles.stripColorTrigger}
                        message={newStyles.stripColor}
                      >
                        <span className='items-center text-xs text-center font-bold uppercase'>
                          {colorHexStripCode}
                        </span>
                      </div>
                      {displayCPStrip ? (
                        <div style={newStyles.popover}>
                          <div style={newStyles.cover} onClick={handleClose} />
                          <SketchPicker
                            color={colorHexStripCode}
                            onChange={(e) => setColorHexStripCode(e.hex)}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                {/* <div className='overflow-hidden rounded px-4 py-4 flex-auto'>
                      <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg'>
                        <div className='px-6 py-4'>
                          <div className=''>
                            <h4 className='text-white'>
                              {' '}
                              &#128640; OLD THEME PREVIEW
                            </h4>
                          </div>
                        </div>
                      </div>
                      {getstyles ? (
                        <div
                          className='overflow-hidden border-2 rounded px-4 py-4 flex-auto'
                          style={getstyles.bgPaperColor}
                        >
                          <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll h-80'>
                            <ExampleColorPickerView
                              paperBg={getstyles.paperColor}
                              questionColor={getstyles.questionColor}
                              answerColor={getstyles.answerColor}
                              stripColor={getstyles.stripColor}
                              fontType={getstyles.fontStyle}
                              buttonColor={getstyles.buttonBgColor}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div> */}
                {/* </div> */}
              </div>

              <div className='col-span-2 overflow-hidden rounded-lg'>
                <div className='overflow-hidden rounded px-4 py-4 flex-auto'>
                  <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg'>
                    <div className='px-6 py-4'>
                      <div className=''>
                        <h4 className='text-white'>
                          {' '}
                          &#128640; EDITOR PREVIEW
                        </h4>
                      </div>
                    </div>
                  </div>
                  {getstyles ? (
                    <div
                      className='overflow-hidden border-2 rounded px-4 py-4'
                      style={newStyles.bgPaperColor}
                    >
                      <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                        <ExampleColorPickerView
                          paperBg={newStyles.paperColor}
                          questionColor={newStyles.questionColor}
                          answerColor={newStyles.answerColor}
                          stripColor={newStyles.stripColor}
                          fontType={newStyles.fontStylee}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </Desktop>
        <Tablet>
          <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
            {/* <div className='sm:grid-cols-3 grid sm:gap-2 gap-3 mt-6'> */}
            <div className='w-full rounded-lg border-b-2'>
              <div className=''>
                <div className='flex items-center'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Font</span>
                  </div>

                  <div className=''>
                    <FormControl style={getstyles.formControl}>
                      <Select
                        input={<BootstrapInput />}
                        placeholder='Pilih Font'
                        defaultValue='Pilih Font'
                        // onChange={handleChangeFont}
                      >
                        <MenuItem value='Pilih Font'>
                          <em>-- Pilih Font --</em>
                        </MenuItem>
                        <MenuItem value='Roboto, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Roboto'
                            fontStyle='Roboto, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Roboto Mono, monospaced'>
                          {' '}
                          <ListFont
                            fontName='Roboto Mono'
                            fontStyle='Roboto Mono, monospaced'
                          />
                        </MenuItem>
                        <MenuItem value='Qahiri, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Qahiri'
                            fontStyle='Qahiri, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='STIX Two Math, serif'>
                          {' '}
                          <ListFont
                            fontName='STIX Two Math'
                            fontStyle='STIX Two Math, serif'
                          />
                        </MenuItem>
                        <MenuItem value='Teko, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Teko'
                            fontStyle='Teko, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Bebas Neue, cursive'>
                          {' '}
                          <ListFont
                            fontName='Bebas Neue'
                            fontStyle='Bebas Neue, cursive'
                          />
                        </MenuItem>
                        <MenuItem value='Anton, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Anton'
                            fontStyle='Anton, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Barlow Condensed, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Barlow Condensed'
                            fontStyle='Barlow Condensed, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Source Code Pro, monospace'>
                          {' '}
                          <ListFont
                            fontName='Source Code Pro'
                            fontStyle='Source Code Pro, monospace'
                          />
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Paper Color</span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPPaper}
                    className=''
                  >
                    <div
                      style={newStyles.paperColorTrigger}
                      message={newStyles.paperColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexPaperCode}
                      </span>
                    </div>
                    {displayCPPaper ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexPaperCode}
                          onChange={(e) => setColorHexPaperCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>
                      Background Paper Color
                    </span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPBgPaper}
                    className=''
                  >
                    <div
                      style={newStyles.bgPaperColorTrigger}
                      message={newStyles.bgPaperColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexPaperBgCode}
                      </span>
                    </div>
                    {displayCPBgPaper ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexPaperBgCode}
                          onChange={(e) => setColorHexPaperBgCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Question Color</span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPQuestion}
                    className=''
                  >
                    <div
                      style={newStyles.questionColorTrigger}
                      message={newStyles.questionColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexQuestionCode}
                      </span>
                    </div>
                    {displayCPQuestion ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexQuestionCode}
                          onChange={changeQuestion}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Answer Color</span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPAnswer}
                    className=''
                  >
                    <div
                      style={newStyles.answerColorTrigger}
                      message={newStyles.answerColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexAnswerCode}
                      </span>
                    </div>
                    {displayCPAnswer ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexAnswerCode}
                          onChange={(e) => setColorHexAnswerCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Strip Color</span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPStrip}
                    className=''
                  >
                    <div
                      style={newStyles.stripColorTrigger}
                      message={newStyles.stripColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexStripCode}
                      </span>
                    </div>
                    {displayCPStrip ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexStripCode}
                          onChange={(e) => setColorHexStripCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className='col-span-2 overflow-hidden rounded-lg'>
              <div className='overflow-hidden rounded py-4 flex-auto'>
                <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg'>
                  <div className='px-6 py-4'>
                    <div className=''>
                      <h4 className='text-white'> &#128640; EDITOR PREVIEW</h4>
                    </div>
                  </div>
                </div>
                {getstyles ? (
                  <div
                    className='overflow-hidden border-2 rounded py-4'
                    style={newStyles.bgPaperColor}
                  >
                    <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                      <ExampleColorPickerView
                        paperBg={newStyles.paperColor}
                        questionColor={newStyles.questionColor}
                        answerColor={newStyles.answerColor}
                        stripColor={newStyles.stripColor}
                        fontType={newStyles.fontStylee}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            {/* </div> */}
          </div>
        </Tablet>
        <Mobile>
          <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
            {/* <div className='sm:grid-cols-3 grid sm:gap-2 gap-3 mt-6'> */}
            <div className='w-full rounded-lg border-b-2'>
              <div className=''>
                <div className='flex items-center'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Font</span>
                  </div>

                  <div className=''>
                    <FormControl style={getstyles.formControl}>
                      <Select
                        input={<BootstrapInput />}
                        placeholder='Pilih Font'
                        defaultValue='Pilih Font'
                        // onChange={handleChangeFont}
                      >
                        <MenuItem value='Pilih Font'>
                          <em>-- Pilih Font --</em>
                        </MenuItem>
                        <MenuItem value='Roboto, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Roboto'
                            fontStyle='Roboto, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Roboto Mono, monospaced'>
                          {' '}
                          <ListFont
                            fontName='Roboto Mono'
                            fontStyle='Roboto Mono, monospaced'
                          />
                        </MenuItem>
                        <MenuItem value='Qahiri, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Qahiri'
                            fontStyle='Qahiri, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='STIX Two Math, serif'>
                          {' '}
                          <ListFont
                            fontName='STIX Two Math'
                            fontStyle='STIX Two Math, serif'
                          />
                        </MenuItem>
                        <MenuItem value='Teko, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Teko'
                            fontStyle='Teko, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Bebas Neue, cursive'>
                          {' '}
                          <ListFont
                            fontName='Bebas Neue'
                            fontStyle='Bebas Neue, cursive'
                          />
                        </MenuItem>
                        <MenuItem value='Anton, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Anton'
                            fontStyle='Anton, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Barlow Condensed, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Barlow Condensed'
                            fontStyle='Barlow Condensed, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Source Code Pro, monospace'>
                          {' '}
                          <ListFont
                            fontName='Source Code Pro'
                            fontStyle='Source Code Pro, monospace'
                          />
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Paper Color</span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPPaper}
                    className=''
                  >
                    <div
                      style={newStyles.paperColorTrigger}
                      message={newStyles.paperColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexPaperCode}
                      </span>
                    </div>
                    {displayCPPaper ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexPaperCode}
                          onChange={(e) => setColorHexPaperCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>
                      Background Paper Color
                    </span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPBgPaper}
                    className=''
                  >
                    <div
                      style={newStyles.bgPaperColorTrigger}
                      message={newStyles.bgPaperColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexPaperBgCode}
                      </span>
                    </div>
                    {displayCPBgPaper ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexPaperBgCode}
                          onChange={(e) => setColorHexPaperBgCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Question Color</span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPQuestion}
                    className=''
                  >
                    <div
                      style={newStyles.questionColorTrigger}
                      message={newStyles.questionColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexQuestionCode}
                      </span>
                    </div>
                    {displayCPQuestion ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexQuestionCode}
                          onChange={changeQuestion}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Answer Color</span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPAnswer}
                    className=''
                  >
                    <div
                      style={newStyles.answerColorTrigger}
                      message={newStyles.answerColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexAnswerCode}
                      </span>
                    </div>
                    {displayCPAnswer ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexAnswerCode}
                          onChange={(e) => setColorHexAnswerCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Strip Color</span>
                  </div>
                  <div
                    style={newStyles.swatch}
                    onClick={handleDisplayCPStrip}
                    className=''
                  >
                    <div
                      style={newStyles.stripColorTrigger}
                      message={newStyles.stripColor}
                    >
                      <span className='items-center text-xs text-center font-bold uppercase'>
                        {colorHexStripCode}
                      </span>
                    </div>
                    {displayCPStrip ? (
                      <div style={newStyles.popover}>
                        <div style={newStyles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexStripCode}
                          onChange={(e) => setColorHexStripCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className='col-span-2 overflow-hidden rounded-lg'>
              <div className='overflow-hidden rounded py-4 flex-auto'>
                <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg'>
                  <div className='px-6 py-4'>
                    <div className=''>
                      <h4 className='text-white'> &#128640; EDITOR PREVIEW</h4>
                    </div>
                  </div>
                </div>
                {getstyles ? (
                  <div
                    className='overflow-hidden border-2 rounded py-4'
                    style={newStyles.bgPaperColor}
                  >
                    <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                      <ExampleColorPickerView
                        paperBg={newStyles.paperColor}
                        questionColor={newStyles.questionColor}
                        answerColor={newStyles.answerColor}
                        stripColor={newStyles.stripColor}
                        fontType={newStyles.fontStylee}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            {/* </div> */}
          </div>
        </Mobile>
      </>
    );
  }

  return contentUi;
}
